module.exports = __webpack_public_path__ + "static/img/RWA666_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWA666_1.png
// module id = +D+K
// module chunks = 0